// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-wrapper[data-v-51c79936] a{padding:2px 4px;margin:0 4px;background-color:#0d8ddc;border-radius:4px;color:#fff;-webkit-transition:background-color .1s ease-out;transition:background-color .1s ease-out}.link-wrapper[data-v-51c79936] a:hover{background-color:#2ea0ec}", ""]);
// Exports
module.exports = exports;
